"use client";

import React, { memo } from "react";
import Image from "next/image";
import Box from "@mui/material/Box";
import PerfectScrollbarComponent from "react-perfect-scrollbar";
import {
  Paragraph,
  Span,
} from "src/lib/components/salify-next-layout/default/components/Typography";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";

import { NavbarRoot, StyledNavbarLinkItem } from "./styles";
import { styled } from "@mui/material/styles";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import SalifyLink from "src/lib/components/link/salify-link";
import { toAssetImages } from "src/lib/utils";

// ==================================================================

const PerfectScrollbar = styled(PerfectScrollbarComponent, {
  shouldForwardProp: (prop) => prop !== "maxHeight",
})(({ maxHeight }) => ({
  maxHeight: maxHeight,
}));

export const customBgColor = [
  "#8037FFB3",
  "#3481F4B3",
  "#3C5F93B3",
  "#38B261B3",
  "#E9A41EB3",
  "#D25236B3",
  "#16BEF3B3",
];

export const CategoryItem = ({ item, ind, isSelected = false }) => (
  <StyledNavbarLinkItem mb="2px" color="grey.700" key={ind} isSelected={isSelected}>
    <SalifyLink href={`/collection/${item.code}`}>
      <Box
        key={item.id}
        sx={{
          color: "grey.700",
          cursor: "pointer",
        }}
      >
        <FlexBox
          gap={1.5}
          className="linkList"
          py={0.75}
          sx={{
            alignItems: "center",
          }}
        >
          <Image
            alt={item.code}
            width={20}
            height={20}
            src={
              item.imageUrlIcon
                ? toAssetImages(item.imageUrlIcon)
                : "/assets/images/06f2ae32-86a2-45ea-bce3-09182a5b9b5d/t-thumb.jpeg"
            }
            style={{
              height: 28,
              width: 28,
              padding: 6,
              borderRadius: 8,
              objectFit: "contain",
              background: customBgColor[ind % customBgColor.length],
            }}
          />
          <Span fontWeight={600} fontSize={14}>
            {item.name}
          </Span>
        </FlexBox>
      </Box>
    </SalifyLink>
  </StyledNavbarLinkItem>
);

const SideNavbar = (props) => {
  const { isFixed, navList, sidebarHeight = "auto", sidebarStyle = "style1" } = props;
  return (
    <PerfectScrollbar maxHeight={sidebarHeight}>
      <NavbarRoot fixed={isFixed} sidebar={sidebarStyle}>
        <div>
          <Box padding="16px 20px 5px 20px">
            <Paragraph fontSize={14} fontWeight={600}>
              <SalifyFallback.Label path="Categories" default="Danh mục" />
            </Paragraph>
          </Box>

          {navList.map((item, ind) => (
            <CategoryItem key={item.code} item={item} ind={ind} />
          ))}
          <Box py={0.75}>
            <SalifyLink href={"/collection"} className="linkList text-blue-500">
              <SalifyFallback.Label path="View All" default="Xem tất cả" />
            </SalifyLink>
          </Box>
        </div>
      </NavbarRoot>
    </PerfectScrollbar>
  );
};

export default memo(SideNavbar);
